<template>
  <div class="content">
    <div class="title-text">
      <p class="title">Update Password</p>
    </div>
    <div class="content-body">
      <div class="update-password-card">
        <div class="card-content">
          <div class="password-inputs">
            <div class="current">
              <label>
                <span class="label">Current Password</span>
                <input v-model="currentPassword" type="password" />
              </label>
            </div>
            <div class="new">
              <label>
                <span class="label">New Password</span>
                <input v-model="newPassword" type="password" />
              </label>
            </div>
            <div class="confirm">
              <label>
                <span class="label">Confirm New Password</span>
                <input v-model="newPasswordConfirm" type="password" />
              </label>
            </div>
          </div>
          <button
            @click="updatePassword"
            class="button-default"
            :disabled="isUpdatePasswordDisabled"
          >
            <span>Update Password</span>
          </button>
        </div>
      </div>
    </div>
    <SnackBar />
  </div>
</template>

<script>
import { M_UPDATE_PASSWORD } from "@/graphql";
import "@/assets/scss/custom/vendors-extensions/_sweetalert.scss";
import "@/assets/scss/custom/vendors-extensions/_braintree.scss";
import SnackBar from "@/components/Custom/SnackBar";
export default {
  name: "UserPassword",
  components: {
    SnackBar
  },
  data() {
    return {
      currentPassword: null,
      newPassword: null,
      newPasswordConfirm: null
    };
  },
  computed: {
    user() {
      return this.$store.getters.getUser;
    },
    isUpdatePasswordDisabled() {
      if (!this.currentPassword) {
        return true;
      } else if (!this.newPassword) {
        return true;
      } else return this.newPassword !== this.newPasswordConfirm;
    }
  },
  methods: {
    async updatePassword() {
      try {
        const result = await this.$apollo.mutate({
          client: "localClient",
          mutation: M_UPDATE_PASSWORD,
          variables: {
            current_password: this.currentPassword,
            new_password: this.newPassword,
            user_id: this.user.id
          }
        });
        if (result.data.update_password.success) {
          await this.$store.dispatch("snack", {
            text: "Success! Your password has been updated."
          });
        } else {
          await this.$store.dispatch("snack", {
            type: "error",
            text: `Oops! Failed to update password.`
          });
        }
      } catch (e) {
        await this.$store.dispatch("snack", {
          type: "error",
          text: `Oops! ${e.message.replace("GraphQL error: ", "")}`
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.update-password-card {
  padding: 0 24px 24px;
  /* BG/type2 */
  background: $bg-type-2;
  /* Shadow */
  box-shadow: 0px 50px 40px rgba(23, 18, 43, 0.3);
  border-radius: 10px;
  .card-top {
    .card-title {
      /* 18/SemiBold */
      font-weight: 600;
      font-size: 18px;
      line-height: 30px;
      /* White */
      color: white;
      mix-blend-mode: normal;
      opacity: 0.9;
    }
    .card-text {
      margin: 0;
      font-size: 14px;
      line-height: 24px;
      /* Text/type0 */
      color: $text-type-0;
      mix-blend-mode: normal;
      opacity: 0.9;
    }
  }
  .card-content {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    .password-inputs {
      margin-top: 24px;
      width: 100%;
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      grid-column-gap: 32px;
      .current,
      .new,
      .confirm {
        label {
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          align-items: baseline;
          .label {
            margin-left: 11px;
            width: 100%;
            /* 12/Bold */
            font-weight: bold;
            font-size: 12px;
            line-height: 15px;
            /* Text/type1 */
            color: #8786ab;
          }
          input {
            margin-top: 6px;
            padding: 13px 11px;
            //width: 100%;
            flex: 1;
            /* Purple-dark */
            background: $purple-dark;
            /* Purple-stroke */
            border: 1px solid $purple-stroke;
            box-sizing: border-box;
            border-radius: 5px;
            outline: none;
            //border: none;
            color: $text-type-0;
            /* 14/Regular */
            font-size: 14px;
            line-height: 17px;
            &:focus {
              outline: none;
              //border: 1px solid $purple;
            }
            &::placeholder {
              color: $text-type-2;
              /* 14/Regular */
              font-size: 14px;
              line-height: 17px;
            }
          }
        }
      }
    }
    button {
      margin-top: 18px;
      padding: 9px 30px;
      &:disabled {
        cursor: not-allowed;
        opacity: 0.5;
      }
    }
  }
}
@keyframes bounce {
  50% {
    transform: scale(1.2);
  }
  75% {
    transform: scale(0.9);
  }
  100% {
    transform: scale(1);
  }
}
@media (max-width: 600px) {
  .password-inputs {
    display: flex !important;
    flex-direction: column;
    input {
      margin-bottom: 10px;
    }
  }
}
</style>
